module.exports = __webpack_public_path__ + "img/vdi-tz-logo.c8e1da3a.jpg";